import React, { Component } from 'react'
import Markdown, { md } from 'features/Markdown'
import { Col, Row } from 'components/Layout'
import IconArrowRight from 'components/Icons/ArrowRight'
import s from './MultiTextBoxes.scss'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import cn from 'classnames'
import { CmsIcon } from 'features/Cms/CmsIcon'
import Helmet from 'react-helmet'

const TextItem = ({ text, title, icon, active, toggleActive }) => (
  <div className={s.outer}>
    <div
      className={cn(s.title, sLay['layout-row'], sLay['layout-align-start-center'], sText.pointer)}
      onClick={toggleActive}
    >
      {icon && <CmsIcon name={icon} size="30" style={{ marginRight: '10px' }} />}
      <h4 className={sLay.flex}>{title}</h4>
      <IconArrowRight size={30} className={sText.accent} />
    </div>
    {active && <Markdown className={s.body} text={text} />}
  </div>
)

export default class MultiText extends Component {
  state = {
    /**
     * [title]: boolean
     */
  }
  toggleActive = title =>
    this.setState({
      [title]: !this.state[title],
    })
  render() {
    const { data, columns = 2 } = this.props
    const dataFiltered = data.filter(item => item.title)
    const halfLength = Math.ceil(dataFiltered.length / 2)
    const firstHalf = dataFiltered.slice(0, halfLength)
    const secondHalf = dataFiltered.slice(halfLength, dataFiltered.length)

    const jsonLdQuestions = dataFiltered.map(({ title, text }) => ({
      '@type': 'Question',
      name: title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: md.render(text || ''),
      },
    }))

    const jsonLd = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: jsonLdQuestions,
    })

    return (
      <Row className={cn(sLay['layout-gt-xs-row'], sLay['layout-xs-column'])}>
        <Col className={cn(sLay[`flex-gt-xs-${Math.floor(100 / columns)}`])}>
          {firstHalf.map(({ title, text, icon }, idx) => (
            <TextItem
              key={idx}
              title={title}
              icon={icon}
              text={text}
              active={this.state[title]}
              toggleActive={() => this.toggleActive(title)}
            />
          ))}
        </Col>
        <Col className={cn(sLay[`flex-gt-xs-${Math.floor(100 / columns)}`])}>
          {secondHalf.map(({ title, text, icon }, idx) => (
            <TextItem
              key={idx}
              title={title}
              icon={icon}
              text={text}
              active={this.state[title]}
              toggleActive={() => this.toggleActive(title)}
            />
          ))}
        </Col>
        <Helmet>
          <script type="application/ld+json">{jsonLd}</script>
        </Helmet>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/MultiText/MultiTextBoxes/MultiTextBoxes.jsx